<template>
  <div class="page flex-col">
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPngda42bf625197ddbb0318b92615e29113bcab76c20772e08a14070f1133f90ea1.png"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />